import Backbone from "backbone";
import SelectList from "./selectList";
import { Dialog } from "./dialog";
import Translator from "../../utils/translator";

interface ISelectDialogOptions extends Backbone.ViewOptions<Backbone.Model> {
    translator: Translator;
    title: string;
    validate?: (status: string) => boolean;
    selectCallback?: (parameter) => void;
    language?: string;
    minWidth?: number;
    isUserNightMode: boolean;
    id?: string;
}

export default class SelectDialog extends Backbone.NativeView<Backbone.Model> {

    private readonly selectCallback: ((parameter) => void) | undefined;
    private readonly validate;
    private readonly translator: Translator;
    private readonly title: string;
    private readonly language?: string;
    private readonly minWidth?: number;
    private readonly isUserNightMode: boolean;
    private readonly dialogId: string;
    private dialog: Dialog | null;
    private selectList: SelectList;

    constructor(options: ISelectDialogOptions) {
        super(options);
        this.selectCallback = options.selectCallback;
        this.validate = options.validate || null;
        this.title = options.title || "";
        this.translator = options.translator;
        this.language = options.language;
        this.minWidth = options.minWidth;
        this.isUserNightMode = options.isUserNightMode;
        this.dialogId = options.id || "select-status";
    }

    render(options: any[] = [], topLabel = "") {
        let templateStr = document.createElement("div");
        this.selectList = new SelectList({
            el: templateStr,
            title: this.title,
            selectCallback: this.onSelectItem.bind(this)
        });
        templateStr.className = "selectDialogContent";
        this.selectList.create(options);

        this.dialog = new Dialog(
            this.dialogId,
            topLabel + templateStr.outerHTML,
            this.translator,
            this.title,
            undefined,
            { minWidth: this.minWidth || undefined, isNightMode: this.isUserNightMode, customClass: "select-dialog" }
        );
        void this.dialog.open(this.translator, this.language).then(() => {
            this.selectList.el = this.dialog?.el && this.dialog.el.querySelector(".selectDialogContent");
            this.selectList.render(options, false);
        });

        return this;
    }

    onSelectItem(id) {
        let isValid = true;
        if (this.validate) {
            isValid = this.validate(id);
        }

        if (isValid) {
            if (this.selectCallback) {
                this.selectCallback(id);
            }
            if (this.dialog) {
                this.dialog.remove();
                this.dialog = null;
            }
        }
    }

    remove() {
        this.dialog && this.dialog.remove();
        this.selectList && this.selectList.remove();

        super.remove();
        return this;
    }
}